import styled from "styled-components";
import Box from "../Box";

export const PointsHistoryWrapper = styled(Box)``;
